
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Toyotaetioncabbookinginpune() {



    const cardData =
    {
        keyword: ' Toyota Etios Cab Booking in Pune',
        heading: 'Prince Cabs: Toyota Etios Cab Booking in Pune',
        headingDescription: 'Prince Cabs provides convenient Toyota Etios Cab Booking in Pune, ideal for airport transfers, corporate travel, family trips, and outstation journeys. Our well-maintained Toyota Etios sedans are known for their comfort, safety, and fuel efficiency, ensuring a smooth and affordable ride. With professional chauffeurs, transparent pricing, and easy booking options, we make every trip hassle-free. Choose Prince Cabs’ trusted Toyota Etios cab booking service in Pune for reliable, comfortable, and budget-friendly travel.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

  "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732, Shaniwar Wada was the grand residence of the Peshwas of the Maratha Empire. Although much of it was destroyed in a fire in 1828, its massive gates, fortified walls, and sprawling courtyards still attract visitors. The evening light-and-sound show narrates tales of Maratha valor and intrigue. Tourists enjoy exploring the ruins and imagining its glorious past. Shaniwar Wada is a symbol of Pune’s rich heritage and cultural identity."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace is an architectural marvel with deep ties to India’s freedom struggle. Mahatma Gandhi and Kasturba Gandhi were imprisoned here during the Quit India Movement. The palace now houses a museum showcasing artifacts, photographs, and personal belongings of Gandhi. Its beautifully landscaped gardens create a peaceful retreat for visitors. Recognized as a national monument, it stands as a timeless reminder of sacrifice and history."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 30 km from Pune, Sinhagad Fort is known for its strategic importance in Maratha history. The 1670 Battle of Sinhagad, led by Tanaji Malusare, is one of its most celebrated tales. Trekkers enjoy the scenic climb, especially during monsoon when mist and greenery cover the hills. From the summit, panoramic views of the Sahyadri ranges are breathtaking. Local food stalls serve traditional pithla-bhakri, making it both a cultural and adventurous experience."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is Pune’s most revered religious site, dedicated to Lord Ganesha. The idol is adorned with gold and ornaments, attracting thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. It is also known for charitable activities that benefit the community. Easily accessible in the city center, it is a must-visit for both spiritual seekers and cultural enthusiasts."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill is one of Pune’s highest points, offering sweeping views of the city. At the summit lies the Parvati Temple complex dedicated to Lord Shiva and Goddess Parvati. The climb of more than 100 steps is rewarded with serenity and spirituality. The Peshwa Museum nearby displays artifacts from Maratha history. Sunrises and sunsets from the hill are especially captivating. It is a favorite spot for devotees, history lovers, and nature seekers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. Its massive stone pillars and Nandi mandapa reflect Rashtrakuta-era architecture. Despite its central location, the temple offers peace and tranquility. Devotees and tourists often visit for meditation and photography. The unfinished sanctum adds to its historical intrigue. It is a hidden heritage gem amidst Pune’s bustling cityscape."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses an extraordinary collection of over 20,000 artifacts compiled by Dr. Dinkar Kelkar. The exhibits include musical instruments, sculptures, everyday items, and the famous recreated Mastani Mahal. The museum reflects India’s cultural diversity and heritage craftsmanship. Both art lovers and historians find it fascinating. The three-story building itself is a heritage attraction. It is one of Pune’s most unique museums."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "The Osho International Meditation Resort in Koregaon Park is one of the world’s most renowned spiritual centers. It attracts visitors from across the globe for meditation, yoga, and wellness programs. Surrounded by lush gardens, the ashram offers a peaceful retreat from city life. The community vibe blends spirituality with cosmopolitan charm. Its modern facilities and tranquil environment make it a unique destination in Pune."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity in Viman Nagar is Pune’s largest shopping and lifestyle mall. It houses hundreds of international and Indian brands, making it a retail paradise. Entertainment includes multiplex cinemas, gaming zones, and regular live events. Food courts and fine dining restaurants add to the appeal. During festivals like Christmas and Diwali, the mall comes alive with special events. It is the go-to hub for shopping and leisure."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, located about 20 km from Pune, is a popular weekend destination. It supplies water to the city and offers a scenic backdrop with surrounding hills. Families enjoy picnics, boating, and evening snacks along the lakeside. During monsoon, the lush greenery enhances its charm. Cool breezes make it an enjoyable escape year-round. It is a refreshing natural retreat for locals and tourists alike."
  },
  {
    "title": "Mulshi Lake",
    "description": "Mulshi Lake, formed by the Mulshi Dam, is a serene getaway near Pune. Surrounded by forests and Sahyadri hills, it is ideal for camping, nature walks, and photography. Monsoon transforms the landscape with waterfalls and misty valleys. Eco-resorts nearby offer comfortable stays amidst nature. Trekkers and couples often choose it for a peaceful weekend. Mulshi blends adventure and relaxation in equal measure."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Chaturshringi Temple, located on Senapati Bapat Road, is one of Pune’s most revered temples. Dedicated to Goddess Chaturshringi, it requires climbing over 100 steps to reach the sanctum. The temple is especially vibrant during Navratri with grand decorations. Devotees from across Maharashtra visit to seek blessings. The hilltop setting also provides panoramic views of the city. It is a blend of faith and tradition."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "The National War Memorial honors Indian soldiers who sacrificed their lives post-independence. The memorial displays tanks, weapons, and war memorabilia. A museum inside narrates stories of courage and patriotism. The evening flag retreat ceremony is a moving experience. It is both educational for children and inspiring for adults. The memorial instills pride and respect for India’s armed forces."
  },
  {
    "title": "Empress Garden",
    "description": "Empress Garden, spread across 39 acres, is a botanical paradise in Pune. Managed by the Agri-Horticultural Society, it houses rare trees, colorful flower nurseries, and shaded walking paths. Families often visit for picnics and leisure. The annual flower show attracts gardening enthusiasts. With colonial-era history, it is one of Pune’s heritage gardens. It offers peace and greenery within the bustling city."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi, Pune’s highest hill, is a favorite spot for trekking, jogging, and cycling. The summit provides panoramic views of the entire city. It is rich in biodiversity, home to several species of birds and plants. Locals gather here for morning walks and yoga sessions. Sunrises and sunsets from Vetal Hill are mesmerizing. It serves as Pune’s green lung and a refreshing escape from urban chaos."
  }
],

"services": [
    {
        "name": "Hire Toyota Etios Cab Online for Outstation",
        "description": "Book a Toyota Etios cab online for your outstation journey from Pune. Enjoy seamless booking, affordable fares, and professional drivers for a smooth and comfortable travel experience to any destination."
    },
    {
        "name": "Pune to Mahabaleshwar Etios Taxi Fare",
        "description": "Get the best Etios taxi fare from Pune to Mahabaleshwar for a relaxing hill station trip. Our well-maintained cabs and courteous drivers ensure a safe and pleasant ride through scenic routes."
    },
    {
        "name": "Pune to Mumbai Toyota Etios Cab Booking",
        "description": "Book your Toyota Etios cab from Pune to Mumbai for a comfortable and budget-friendly intercity travel option. Ideal for airport transfers, business trips, or family travel with reliable service."
    },
    {
        "name": "Pune to Goa Etios Cab",
        "description": "Travel to Goa from Pune in a Toyota Etios cab offering comfort, space, and safety. Our service includes experienced drivers, timely pickups, and fixed pricing for a worry-free beach holiday journey."
    },
    {
        "name": "Pune to Shirdi Etios Cab",
        "description": "Book an Etios cab from Pune to Shirdi for a spiritual and peaceful journey. Enjoy clean vehicles, comfortable seating, and affordable round-trip packages tailored to your schedule."
    },
    {
        "name": "Pune Airport Toyota Etios Taxi Fare",
        "description": "Avail fixed and affordable Toyota Etios taxi fares to and from Pune Airport. Our airport transfer service offers timely pickups, flight monitoring, and experienced drivers to ensure stress-free travel."
    },
    {
        "name": "Toyota Etios on Rent in Pune Airport",
        "description": "Get Toyota Etios cars on rent directly from Pune Airport. Ideal for business or leisure travel, our rental service offers instant bookings, clean cars, and flexible plans suited to your itinerary."
    },
    {
        "name": "Toyota Etios Car Hire for Outstation",
        "description": "Hire a Toyota Etios for your outstation travel needs from Pune. Our outstation cab service ensures reliable performance, comfortable seating, and competitive rates for long-distance journeys."
    },
    {
        "name": "Etios Dzire Cab Alternative",
        "description": "Looking for an alternative to Dzire cabs? Choose Toyota Etios for similar comfort with better ride quality and luggage space, ideal for local and long-distance trips from Pune."
    },
    {
        "name": "Affordable Etios Rental Pune",
        "description": "Choose our affordable Etios rental options in Pune for local use, airport transfers, and weekend getaways. Enjoy value-for-money rates with clean cars and professional drivers."
    },
    {
        "name": "Luxury Etios Taxi Service",
        "description": "Experience luxury at an affordable price with our premium Etios taxi service. Perfect for executives, couples, or families looking for refined travel with quality interiors and courteous chauffeurs."
    }
],
"tableData": [
    ["Hire Toyota Etios Cab Online for Outstation", "Pune to Mahabaleshwar Etios Taxi Fare"],
    ["Pune to Mumbai Toyota Etios Cab Booking", "Pune to Goa Etios Cab"],
    ["Pune to Shirdi Etios Cab", "Pune Airport Toyota Etios Taxi Fare"],
    ["Toyota Etios on Rent in Pune Airport", "Toyota Etios Car Hire for Outstation"],
    ["Etios Dzire Cab Alternative", "Affordable Etios Rental Pune"],
    ["Luxury Etios Taxi Service", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Toyota Etios Cab Booking in Pune",
        "WhyChoosedescription": "Prince Cabs offers dependable Toyota Etios cab services across Pune for city rides, airport transfers, business meetings, and outstation trips. Known for its comfort, fuel efficiency, and smooth performance, the Etios is an ideal choice for solo travelers, couples, and small families looking for a safe and budget-friendly ride."
    },
    {
        "WhyChooseheading": "Comfortable and Clean Sedans at Your Service",
        "WhyChoosedescription": "Our Etios cabs feature plush, well-cushioned seating, ample legroom, clean interiors, and efficient air-conditioning, making every ride pleasant. Whether you’re traveling for 30 minutes or several hours, our sedans ensure you experience smooth and stress-free mobility in and around Pune."
    },
    {
        "WhyChooseheading": "Professional Drivers with Local Route Expertise",
        "WhyChoosedescription": "Our courteous, uniformed drivers are well-versed with Pune’s roads, traffic conditions, and shortcuts, ensuring timely pickups and drop-offs. Whether you need to navigate busy city streets or head out on the highway, our drivers focus on your safety and punctuality."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for Every Travel Need",
        "WhyChoosedescription": "We offer flexible booking choices for hourly rentals, point-to-point transfers, airport pickups/drop-offs, and full-day or outstation use. Book your Etios cab easily via call, WhatsApp, or our website — with instant confirmations and zero booking charges."
    },
    {
        "WhyChooseheading": "Transparent & Affordable Pricing",
        "WhyChoosedescription": "Enjoy competitive and transparent fares with no hidden costs. Our pricing includes all essential charges like driver allowance, fuel, and taxes. Choose from per-km billing or fixed-rate packages, depending on your travel needs. Payments are accepted via UPI, cards, net banking, or cash."
    },
    {
        "WhyChooseheading": "Regularly Sanitized & Well-Maintained Vehicles",
        "WhyChoosedescription": "Each Etios cab in our fleet is regularly serviced and undergoes strict hygiene protocols before and after every ride. We ensure our vehicles are spotless, mechanically sound, and equipped with safety features like seat belts and airbags, offering you a safe and hygienic travel experience."
    },
    {
        "WhyChooseheading": "24/7 Support and On-Time Service Guarantee",
        "WhyChoosedescription": "Our customer care team is available 24/7 to support your booking, answer queries, and assist with last-minute changes. With Prince Cabs, you can count on on-time arrivals and dependable service, no matter what time of day or night you’re traveling."
    }
]























    }

const faqData = [
    {
        question: 'Can I book a Toyota Etios cab in Pune with Prince Cabs?',
        answer: 'Yes, Prince Cabs offers reliable Toyota Etios cab bookings in Pune for local, airport, and outstation travel with professional drivers and clean vehicles.',
    },
    {
        question: 'What are the uses of booking a Toyota Etios cab in Pune?',
        answer: 'Etios cabs are ideal for city commutes, airport transfers, business meetings, and budget-friendly outstation trips for small groups or solo travelers.',
    },
    {
        question: 'Is the Toyota Etios suitable for long-distance travel?',
        answer: 'Absolutely! The Etios offers great mileage, comfortable seating, and ample boot space—perfect for long outstation journeys from Pune.',
    },
    {
        question: 'How do I book a Toyota Etios cab in Pune?',
        answer: 'You can book online through our website or call our support team. Provide your pickup location, travel plan, and we’ll assign an Etios cab promptly.',
    },
    {
        question: 'Are Etios cabs available for hourly rental in Pune?',
        answer: 'Yes, Prince Cabs offers flexible hourly packages for local use within Pune. Choose from 4, 8, or 12-hour rental options with an experienced driver.',
    },
    {
        question: 'Are the Toyota Etios cabs clean and well-maintained?',
        answer: 'Yes, all Etios cabs are regularly serviced, sanitized before every trip, and driven by verified professionals to ensure safety and comfort.',
    },
    {
        question: 'What is the starting fare for Toyota Etios cab booking in Pune?',
        answer: 'Etios cab fares in Pune start from ₹11/km for outstation trips. Local and airport transfer pricing varies by duration and distance.',
    },
];

const testimonials = [
    {
        name: "Mr. Rajesh Thakur",
        position: "IT Professional",
        text: "I booked a Toyota Etios from Prince Cabs for daily office commute. The ride was always on time and super comfortable. Great service!",
        image: "/img/testimonial/testimonial-thumb-etios-booking-1.png",
    },
    {
        name: "Ms. Anuja Patil",
        position: "Frequent Traveler",
        text: "Booked an Etios cab for an outstation trip from Pune. Smooth journey, clean car, and very courteous driver. Highly recommend Prince Cabs!",
        image: "/img/testimonial/testimonial-thumb-etios-booking-2.png",
    },
];





























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Toyota Etios Cab Booking in Pune",
  "description": "Hire Toyota Etios cab online for outstation trips from Pune including popular routes like Mahabaleshwar, Mumbai, Goa, and Shirdi. Affordable and luxury Etios taxi service with airport pickups.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Toyota Etios Cab Online Booking",
    "Etios Taxi for Outstation",
    "Pune to Mahabaleshwar Etios Taxi",
    "Pune to Mumbai Toyota Etios Cab",
    "Pune to Goa Etios Cab",
    "Pune to Shirdi Etios Cab",
    "Airport Taxi Service Pune",
    "Luxury Etios Taxi Service"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};



    return (
        <div>
<Helmet>
  <title>Toyota Etios Cab Booking in Pune | Affordable & Luxury Etios Taxi</title>
  <meta
    name="description"
    content="Hire Toyota Etios cab online for outstation trips from Pune including popular routes like Mahabaleshwar, Mumbai, Goa, and Shirdi. Affordable and luxury Etios taxi service with airport pickups."
  />
  <meta
    name="keywords"
    content="Hire Toyota Etios Cab Online for Outstation, Pune to Mahabaleshwar Etios Taxi Fare, Pune to Mumbai Toyota Etios Cab Booking, Pune to Goa Etios Cab, Pune to Shirdi Etios Cab, Pune Airport Toyota Etios Taxi Fare, Toyota Etios on Rent in Pune Airport, Toyota Etios Car Hire for Outstation, Etios Dzire Cab Alternative, Affordable Etios Rental Pune, Luxury Etios Taxi Service"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/43.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Toyotaetioncabbookinginpune ;